import { type FC, useState } from 'react';

import ListItem, { type ListItemType } from '@zen/Components/VerticalList/ListItem';
import { Counter, Icon } from '@zen/DesignSystem';
import type { Nullable } from '@zen/utils/typescript';

interface Props {
  containers: ListItemType[];
  missingCounts: Record<string, number>;
  onContainerSelect: (conatinerId: string) => void;
}

const ContainersList: FC<Props> = ({ containers, missingCounts, onContainerSelect }) => {
  const [selectedContainerId, setSelectedContainerId] = useState<Nullable<string>>(containers[0].id);

  const handleContainerSelect = (conatinerId: string) => {
    setSelectedContainerId(conatinerId);
    onContainerSelect(conatinerId);
  };

  return (
    <div className="border-r border-solid border-grey-lighter">
      {containers.map((containerItem) => {
        const counter =
          missingCounts[containerItem.id] > 0 ? (
            <Counter className="text-md" type="active" value={missingCounts[containerItem.id]} />
          ) : (
            <Counter className="invisible text-md" type="active" value={1} />
          );

        const stateIcon = missingCounts[containerItem.id] > 0 ? <Icon icon="zicon-tick-oval" /> : <Icon icon="zicon-tickoval" />;

        return (
          <ListItem
            key={containerItem.id}
            counter={counter}
            isSelected={containerItem.id === selectedContainerId}
            item={containerItem}
            onClick={() => handleContainerSelect(containerItem.id)}
            stateIcon={stateIcon}
          />
        );
      })}
    </div>
  );
};

export default ContainersList;
